<template>
  <div id="app" class="" style="height: 100%">
    <router-view />
    <v-overlay :value="loadingMenu" opacity=".9">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
      <p>{{ loadMsg }}</p>
    </v-overlay>
  </div>
</template>

<script>
//import "../src/assets/css/uv_style.css";
import "../src/assets/css/WebFont/font-css/LineIcons.css";
import FirebaseConfig from "./helpers/FirebaseConfig.js";
const firebaseConf = new FirebaseConfig();
import { Crisp } from "crisp-sdk-web";
let fSingleton;
export default {
  name: "app",
  components: {},
  data() {
    return {
      loadMsg: "Cargando",
      loadingMenu: true,
    };
  },
  methods: {
    async getAppTenant() {
      await this.$store.dispatch("FirebaseApp/initFirebaseApp", null, {
        root: true,
      });
      fSingleton = await this.$store.getters.getFirebaseApp;
      if (firebaseConf.getTenantInLocal()) {
        if (fSingleton?.mainApp?.name !== firebaseConf.getTenantInLocal()) {
          return await this.getAppTenant();
        }
      }
      return fSingleton;
    },
    async getCofig() {
      if (firebaseConf.getTenantInLocal()) {
        let tenantConfig = await firebaseConf.getUserTenantConfig(
          firebaseConf.getTenantInLocal()
        );
        this.$store.commit(
          'setConfigTenant',
          tenantConfig.conf
        );
      }

    }
  },
  computed: {
    configTenant() {
      return this.$store.getters.getConfigTenant;
    }
  },
  watch: {
    configTenant: {
      handler(newVal) {
        if (newVal && newVal.Nombre) {
          document.title = `PGS | ${newVal.Nombre}`;
        } else {
          document.title = "PGS";
        }
      },
      deep: true,
      immediate: true
    }
  },
  beforeMount: async function () {
    fSingleton = await this.getAppTenant();
    this.getCofig()
    const user = await this.$store.getters.getFirebaseApp.auth
      .getCurrentUserFirstTime;
    let tenant = localStorage.getItem("ParGolfTenant")
    try {
      Crisp.configure("77a74e9c-66d0-40bb-827a-36c31685775c");

      Crisp.user.setNickname(tenant + '-' + ((user) ? user?.displayName : ""));
      Crisp.load();
    } catch (e) {
      console.log(e)
    }
    if (user) {
      Crisp.user.setNickname(tenant + '-' + ((user) ? user?.displayName : ""));

      try {
        //window.$crisp.push(["set", "user:nickname", [user.tokenResult.claims.Tenant+'-'+user.displayName]]);
        await this.$store.dispatch("listeners/listenerRVATarifas");
        // this.loadMsg += "Cargando Tipos de Cambio"
        await this.$store.dispatch("listenerTiposCambio");
        //this.loadMsg += "Cargando Permisos de usuario\n"
        await this.$store.dispatch("listenerCatalogoPermisos");
        let prodList = await this.$store.dispatch("listenerProducts");
        //this.loadMsg += "Cargando Productos\n"
        await this.$store.dispatch("listenerClientes");
        //this.loadMsg += "Cargando Clientes\n"
        await this.$store.dispatch("listenerPDVMonedasLista");
        await this.$store.dispatch("listenerPDVPagosTipos");
        await this.$store.dispatch("listeners/listenerMBSBeneficios");
        await this.$store.dispatch("listeners/listenerMBSMembresias");
        await this.$store.dispatch("listeners/listenerMBSPlanes");
        await this.$store.dispatch("listeners/listenerMBSPeriodos");
        await this.$store.dispatch("getRVACatalogo");
        await this.$store.dispatch("getRVADepartamentos");
        await this.$store.dispatch("getOrigenes");
        await this.$store.dispatch("getPDVDepartamentos");
        await this.$store.dispatch("getAfiliados");
        await this.$store.dispatch("listeners/listenerBNKLineas");
        await this.$store.dispatch("modificadores/listenerModificadores");
        this.$store.dispatch("listenerInventariosWeb", this);
        this.loadingMenu = false
      } catch (e) {
        this.loadingMenu = false
      }

    }

    this.loadingMenu = false
  },
};
</script>

<style>
/*.swal2-actions {
  direction: rtl !important;
}*/

.pc-bg {
  background: #404c95 !important;
}

.pc-tc {
  color: #404c95 !important;
}

.marginlefting {
  margin-left: 60px !important;
}

.displaynone {
  display: none !important;
}

.displayblock {
  display: block !important;
}

.sidebar .item i {
  font-size: 24px;
  margin-top: -5px !important;
}

.logo {
  height: 148px !important;
  padding: 10px !important;
}

.logo img {
  width: 70% !important;
  height: 100px !important;
}

.title.item {
  padding: 0.92857143em 1.14285714em !important;
}

.dropdown .menu .header {
  padding-top: 3.9px !important;
  padding-bottom: 3.9px !important;
}

.Dashboard__sidebar {
  width: 240px !important;
  height: 100%;
  max-height: 100%;
  position: absolute;
  top: 48px;
  left: 0;
  margin: 0 !important;
  padding-top: 1em;
  -webkit-transform: translateX(-250px);
  transform: translateX(-250px);
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
  will-change: transform;
  transition-duration: 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: transform;
  transition-property: transform, -webkit-transform;
  z-index: 5;
}

.Dashboard__sidebar.visible {
  -webkit-transform: translateX(0);
  transform: translateX(0);
}

.Dashboard__content {
  padding: 10px;
  /*margin-left: 260px !important;*/
  min-height: calc(100vh) - 48px;
  /*background-color: #EFEFEF;*/
}

.Dashboard__content>.content {
  padding: 1.5em;
}

#sidebarToggle {
  display: block;
}

.text.center {
  text-align: center;
}

.inverted.text {
  color: #fff !important;
}

.inverted.grey.text {
  color: #aaa !important;
}

.Dashboard__content>.ui.vertical.segment {
  padding: 0;
}

.ui.inverted.light.grey.segment {
  background-color: lightgray !important;
  color: #000 !important;
}

@media screen and (min-width: 1025px) {
  .Dashboard__sidebar {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }

  #sidebarToggle {
    display: none;
  }
}

@media screen and (max-width: 1024px) {
  .Dashboard__content {
    margin-left: 0 !important;
  }
}

@media only screen and (device-width: 768px) {

  /* For general iPad layouts */
  .toc {
    display: none;
  }

  .menubtn {
    display: flex !important;
  }

  .article {
    margin-left: 0px !important;
  }

  .float-menu {
    position: initial !important;
  }
}

@media only screen and (max-width: 700px) {
  .ui.fixed.menu {
    /*display: none !important;*/
  }

  .toc {
    display: none;
  }

  .float-menu {
    position: initial !important;
  }

  .menubtn {
    display: flex !important;
  }

  .article {
    margin-left: 0px !important;
  }

  .secondary.pointing.menu .item,
  .secondary.pointing.menu .menu {
    display: none;
  }

  .secondary.pointing.menu .toc.item {
    display: block;
  }

  .masthead.segment {
    min-height: 350px;
  }

  .masthead h1.ui.header {
    font-size: 2em;
    margin-top: 1.5em;
  }

  .masthead h2 {
    margin-top: 0.5em;
    font-size: 1.5em;
  }
}

.v-main__wrap {
  background-color: #fafafa !important;
}

body {
  background: #fff;
  font-family: "Poppins", sans-serif !important;
}
</style>
